var setUpload = function () {
    $(".editor-selection .btn-upload").addClass("active");
    $(".editor-selection .btn-editor").removeClass("active");
    $('#edit-design-button').hide();
    $('#add-basket-button').show();
    $('#editor-flag-input').val(0);
    $('#attachments_card').show();
}

var setEditor = function () {
    $(".editor-selection .btn-editor").addClass("active");
    $(".editor-selection .btn-upload").removeClass("active");
    $('#add-basket-button').hide();
    $('#edit-design-button').show();
    $('#editor-flag-input').val(1);
    $('#attachments_card').hide();
}

// execute the function when the page loads
$(document).ready(function () {
    if ($('#editor-flag-input').val() === "1") {
        setEditor();
    } else {
        setUpload();
    }
});

$(".editor-selection .btn-upload").click(setUpload);
$(".editor-selection .btn-editor").click(setEditor);

$('#nav_menu .nav-link').on('click', function () {
    setTimeout(function () {
        $('#nav_menu .nav-link').each(function () {
            if (!$(this).siblings(".submenu").hasClass("show")) {
                $(this).addClass("collapsed");
            }
        })
    }, 500);
});

$('.add-wishlist-button').click(function (e) {
    var that = $(this);
    var inputForm = "";
    $.ajax({
        type: 'POST',
        url: '/add_to_wishlist/' + that.data("id"),
        success: function (data) {
            that.hide();
            that.siblings('.remove-wishlist-button').show();
        }
    });
});

$('.remove-wishlist-button').click(function (e) {
    var that = $(this);
    $.ajax({
        type: 'POST',
        url: '/remove_from_wishlist/' + that.data("id"),
        success: function (data) {
            that.hide();
            that.siblings('.add-wishlist-button').show();
        }
    });
});

$('.add-saved-configuration-button').click(function (e) {
    var that = $(this);
    var inputForm = "";
    if ($('#PrintData').length) {
        var printData = JSON.parse($("#PrintData").val());
        inputForm = printData.inputForm;
    }
    $.ajax({
        type: 'POST',
        url: '/add_to_saved_configuration/' + that.data("id"),
        data: {
            "inputForm": inputForm
        },
    });
});

function checkModal(modalId) {
    if ($("#" + modalId).length) {
        return $("#" + modalId);
    } else {
        return $(document.body);
    }
}

$(document).ready(function () {
    var customAdapter = $.fn.select2.amd.require('select2/data/customAdapter');
    if ($("#repository_code").length) {
        $("#repository_code").select2({
            theme: "bootstrap4",
            minimumResultsForSearch: 1,
            dataAdapter: customAdapter,
            allowClear: true,
            dropdownParent: checkModal("repository-modal"),
            placeholder: function () {
                $(this).data('placeholder');
            },
        });
    }
});
